import { UserInfoDto } from 'src/app/model/account/userinfo.dto';
import { UpdateUserInfoDevicesCountDto } from 'src/app/model/account/update-user-info-devices-count.dto';
import { HttpClient } from '@angular/common/http';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { ADPResourceService } from 'digital-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

  /**
   * This service writes user information to the Azure Cosmos DB UserInfo container for reporting purposes
   * UserInfo captures user data such as
   *    EmailAddress,  DealerId, ContractStatus, IsUserPrimary, RegistrationSource (WEB or MOBILE App), LastLoginSource (WEB or MOBILE App), DeviceCount
   */
export class UserInfoReportingService {
  middlewareUrl: string;
  accountPath: string;

  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    public resourceService: ADPResourceService,
  ) {

  }

  /**
   *  updates the Azure Cosmos DB UserInfo container for this user at login
   *
   * @param userInfo This is the UserInfoDto data object
   *   EmailAddress - user's email used for login
   *   DealerId - dealer code for user's contract
   *   ContractStatus - contract status value ex. A = active, C = cancelled
   *   IsUserPrimary - is the user the primary user on the contract
   *   RegistrationSource - which environment the user is accessing the app from: 'WEB' | 'MOBILE_APP';
   *   LastLoginSource - which environment the user is accessing the app from:  'WEB' | 'MOBILE_APP';
   *   DeviceCount - number of devices in the user's inventory
   *
   * @returns
   */
  updateUserInfoAtLogin(userInfo: UserInfoDto) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
    return this.http.post<string>(`${this.middlewareUrl}${this.accountPath}update-user-info-at-login`, userInfo);
  }

  /**
   *  update the user's inventory device count in the Azure Cosmos DB UserInfo container
   *
   * @param userInfoDevicesCount This is the UpdateUserInfoDevicesCountDto data object to update the user's inventory device count
   *   EmailAddress - user's email used for login
   *   DeviceCount - number of devices in the user's inventory
   *
   * @returns
   */
  updateUserInfoDevicesCount(userInfoDevicesCount: UpdateUserInfoDevicesCountDto) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
    return this.http.post<string>(`${this.middlewareUrl}${this.accountPath}update-user-info-devices-count`, userInfoDevicesCount);
  }
}
